import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';
import UDCompactCheckbox from 'ud-form/components/compact-checkbox';

/**
 * Флажок инспектора: кит-флажок `UDCompactCheckbox` с мелкой подписью строки инспектора. Раньше каждый инспектор
 * держал свою обёртку-`<label>` вокруг сырого `<input type="checkbox">` (`CheckboxLabel`, `CheckRow`).
 */
const InspectorCheckbox = styled(UDCompactCheckbox)`
  font-size: 12px;
  color: ${theme.colors.DarkBlue400};
`;

export default InspectorCheckbox;
